import React, { FunctionComponent, useContext } from 'react'
import { Redirect } from 'react-router-dom'
import { useAuth0 } from '../contexts/auth0'
import { WorkspaceContext } from '../contexts/workspace'
import meltanoLogo from 'src/assets/images/svgs/meltano-logo.svg'
import 'src/assets/css/views/accountProvisioning.css'

const CONTACT_PAGE = 'https://meltano.com/contact'

/*
 * Landing page for a signed-in profile that has no workspaces and cannot create one.
 *
 * When the profile's account has no spare workspace capacity, the catalog omits
 * the 'new workspace' link from the profile and there is nothing for the user to
 * do in the app until support provisions them. Tell them that plainly rather than
 * dropping them on a workspace form that would 403 on submit.
 */
const AccountProvisioning: FunctionComponent<any> = () => {
  const { logout, user } = useAuth0()
  const { isOwner, workspaces } = useContext(WorkspaceContext)

  if (isOwner() || workspaces.length > 0) {
    return <Redirect to="/" />
  }

  const email = user?.email

  const logoutWithRedirect = () => {
    logout({
      returnTo: window.location.origin
    })
  }

  return (
        <div className="workbench">
            <div className="account-provisioning content-center">
                {/* decorative: the Toolbar brand image on this page already carries
                    alt="Meltano", and the heading below names the product. A second
                    "Meltano" alt would just be read out twice. */}
                <img
                    className="account-provisioning-logo"
                    src={meltanoLogo}
                    alt=""
                    aria-hidden="true"
                />
                <h1>Thanks for signing up - we&apos;ll help you get started</h1>
                <p>
                    Your Meltano profile has been created, but it doesn&apos;t have a
                    workspace yet. If your company already has an account, you&apos;ll need
                    someone to invite you to the workspace.
                </p>
                <p>
                    If you&apos;re new to Meltano Cloud, please{' '}
                    <a href={CONTACT_PAGE} target="_blank" rel="noopener noreferrer">contact us</a> to provision your account.
                </p>
                {email && (
                    <p>
                        You&apos;re signed in as{' '}
                        <span className="account-provisioning-email">{email}</span>.
                    </p>
                )}
                <div className="account-provisioning-actions">
                    <a
                        href="/"
                        onClick={evt => {
                          evt.preventDefault()
                          logoutWithRedirect()
                        }}
                    >
                        Return to Login
                    </a>
                </div>
            </div>
        </div>
  )
}

export default AccountProvisioning
